import NextLink from 'next/link';
import type { ComponentProps } from 'react';

type NoPrefetchLinkProps = Omit<ComponentProps<typeof NextLink>, 'prefetch'> & {
  prefetch?: false;
};

/** Project-wide Link contract: navigation is user initiated, never prefetched. */
export default function Link({ prefetch: _prefetch, ...props }: NoPrefetchLinkProps) {
  return <NextLink {...props} prefetch={false} />;
}
